import { Helper, DocumentReferenceType } from "../core/util/helper";
import { General } from "../../siteManagement/general";
import { Commands } from "../core/util/commandManager";
import { SheetEventType } from "../../siteManagement/sheet";
import DocumentsListApp, { DocumentsListAppProps } from "../documents/documents";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { BaseComponentProps, BaseField } from "../core/components/baseComponentProps";
import { EmailPropsContext } from "./email";
import { CommandManagerAPI } from "../commonInterfaces";
import { NotificationHelper } from "../core/util/notificationHelper";
import React from "react";
export class AttachmentsSelector extends React.Component<EmailFileSelectorProps, AttachmentsSelectorState> {
    
    constructor(props) {
        super(props)
        this.state = {
            selectedDocuments: [],
            selectedFiles: []
        }
        this.initApp();
    }


    private initApp = () => {
        if (!Helper.isNullOrEmpty(this.props.value) && !this.props.disabled) {
            this.loadDocData(this.props.value);
        } else if (this.props.disabled && this.state.selectedDocuments.length > 0) {
            this.loadDocData(this.state.selectedDocuments.map((d) => d.id));
        }
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data) => {
            if (data.command == "addFiles" && Helper.hasValue(data.files)) {
                this.handleDropppedFiles(data);
            } else if (data.command === "addTemplateFiles") {
                this.handleTemplateFiles(data);
            }
        });

        if (this.props.context.forward) {
           this.loadDocsFromForwarding()
        }

    }

    private handleDropppedFiles = (data) => {
        const selectedFiles = this.state.selectedFiles;
        const files = data.files as FileList;
        for (let i = 0; i < files.length; i++) {
            const file = files.item(i);
            if (!this.isFileExtensionAllowed(file)) {
                continue;
            }

            selectedFiles.push({
                elementRef: null,
                labelRef: null,
                file: file,
                fileName: file.name,
                filePath: null
            });
        }
        this.props.onChange({ model: "files" }, selectedFiles.map((f) => { return f.file }));
        this.setState({ selectedFiles: selectedFiles });
    } 

    private handleTemplateFiles = (data) => {
        this.loadDocData(data.docs)
    }

    private loadDocData = async (docIds: number[]) => {
        const result = await HTTPService.post<JsonResultClass<any[]>>("EmailSender/GetTemplateDocs", { docIds: docIds });
        if (result.Code == 0) {
            let docs = this.state.selectedDocuments;
            result.Data.forEach((doc) => {
                docs.push({
                    docObject: null,
                    documentName: doc.Title,
                    id: doc.DocId,
                    labelRef: null,
                    fileName: doc.DocumentName
                });
            })
            docs = docs.filter((item, index, self) => {
                return self.findIndex(f => f.id === item.id) === index;
            })
            this.props.onChange({ model: "docs" }, docs.map((d) => { return d.id }), docs);
            this.setState({ selectedDocuments: docs });
        }
    }

    private loadDocsFromForwarding = async () => {
        const jobId = this.props.context.keyVal1;
        if (!Helper.hasValue(jobId))
            return;
        const { Code, AdditionalData } = await HTTPService.get<JsonResultClass<any[]>>("EmailSender/GetForwardDocs?jobId=" + jobId);
        if (Code == 0) {
            const { internalDocs, attachedDocs } = AdditionalData;  
            let docs = this.state.selectedDocuments;
            internalDocs.forEach((doc) => {
                docs.push({
                    docObject: null,
                    documentName: doc.Title,
                    id: doc.DocId,
                    labelRef: null,
                    fileName: doc.DocumentName
                });
            })
            docs = docs.filter((item, index, self) => {
                return self.findIndex(f => f.id === item.id) === index;
            })

            const selectedFiles = this.state.selectedFiles;
            for (let i = 0; i < attachedDocs.length; i++) {
                selectedFiles.push({
                    elementRef: null,
                    labelRef: null,
                    file: null,
                    fileName: attachedDocs[i].Title,
                    filePath: attachedDocs[i].DocumentName
                });
            }




            this.setState({ selectedDocuments: docs, selectedFiles: selectedFiles }, () => {
                this.props.onChange({ model: "docs" }, docs.map((d) => { return d.id }), docs);
                this.props.onChange({ model: "attachedFiles" }, selectedFiles);

            });
        }
    }



    private openSelectFileDialog = () => {
        const fileInput = $("<input>").hide().addClass("innoFileInput");
        fileInput.attr("type", "file");
        $(fileInput).on("change", (ev) => {


            const file = (ev.target as HTMLInputElement).files[0];
            if (!this.isFileExtensionAllowed(file)) {
                return;
            }
            const files = this.state.selectedFiles;
            files.push({
                file: file,
                fileName: file.name,
                elementRef: $(ev.target),
                labelRef: null,
                filePath: null
            });
            this.props.onChange({ model: "files" }, files.map((f) => { return f.file }));
            this.setState({ selectedFiles: files });
        });
        $("body").append(fileInput);
        fileInput.click();
    }



    private isFileExtensionAllowed = (file: File) => {
        if (!Helper.hasValue(this.props.context.notAllowedDocumentFileTypes) || this.props.context.notAllowedDocumentFileTypes.length == 0)
            return true;

        const ext = file.name.split('.').pop()
        const fileExtensionOk = this.props.context.notAllowedDocumentFileTypes.findIndex(f => f.toLowerCase() == ext.toLowerCase()) == -1;
        if (!fileExtensionOk) {
            NotificationHelper.showErrorMessage(Helper.getTranslation("Dokument.NotAllowedFT").replace("{x}", ext))
        }
        return fileExtensionOk;
    }

    private removeFile = (index: number, file: FileWrapper) => {
        file.labelRef.animate({
            width: "0px"
        }, 500, () => {
            const files = this.state.selectedFiles;
            if (Helper.hasValue(files[index].elementRef)) {
                files[index].elementRef.remove();
            }
            files.splice(index, 1);
            this.props.onChange({ model: "files" }, files.map((f) => { return f.file }));
            this.setState({ selectedFiles: files });
        });
    }

    private documentExists = (id: number): boolean => {
        return Helper.hasValue(this.state.selectedDocuments.find(f => f.id === id));
    }

    private addDocument = () => {
        const props: DocumentsListAppProps = {
            entity: Helper.createEmptyEntity(),
            context: {
                contextType: "",
                keyVal1: this.props.context.itemKey,
                keyVal2: this.props.context.keyVal2,
                key1: "",
                key2: ""
            },
            type: this.getDocumentType(this.props.context.appContext),
            selectMode: true
        }
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this.props.field.additional.labels.document);

        sheet.bind(SheetEventType.RowClicked, (doc) => {
            if (!this.documentExists(doc.Dokuid)) {
                const docs = this.state.selectedDocuments;
                docs.push({
                    docObject: doc,
                    documentName: doc.Titel,
                    id: doc.Dokuid,
                    labelRef: null,
                    fileName: doc.FileName
                });
                this.props.onChange({ model: "docs" }, docs.map((d) => { return d.id }), docs);
                this.setState({ selectedDocuments: docs });
            }
        });
        sheet.show(() => {
            sheet.mountContent(DocumentsListApp, props);
        });
    }

    private removeDoc = (index: number, doc: DocumentWrapper) => {
        doc.labelRef.animate({
            width: "0px"
        }, 500, () => {
            const docs = this.state.selectedDocuments;
            docs.splice(index, 1);
            this.props.onChange({ model: "docs" }, docs.map((d) => { return d.id }));
            this.setState({ selectedDocuments: docs });
        });
    }

    private renderSelectors = () => {
        if (this.props.disabled) {
            return null;
        } else {
            return (
                <div style={{ display: "flex", justifyContent: "flex-end", fontSize: "13px" }}>
                    {
                        this.props.context.filesEnabled ?
                            <a style={{ marginLeft: "5px" }} draggable={false} onClick={this.openSelectFileDialog}>{this.props.field.additional.labels.local}</a>
                            : null
                    }
                    {
                        this.props.context.documentsEnabled && !Helper.isNullOrEmpty(this.getDocumentType(this.props.context.appContext).toString()) ?
                            <a style={{ marginLeft: "5px" }} draggable={false} onClick={this.addDocument}>{this.props.field.additional.labels.document}</a>
                            : null
                    }
                </div>
            );
        }
    }

    private renderSummary = () => {
        return (
            <div style={{ padding: "3px 7px", margin: "3px 0px", fontSize: 11, border: "1px solid #dbdbdb", borderRadius: "var(--border-radius)", color: "#242424" }}>
                {
                    this.state.selectedFiles.length === 0 && this.state.selectedDocuments.length === 0 ?
                        this.props.field.additional.labels.noFiles :
                        (
                            this.props.field.additional.labels.existingFiles + ": " + this.state.selectedFiles.length
                            + ", " + this.props.field.additional.labels.existingDocuments + ": " + this.state.selectedDocuments.length
                        )
                }
            </div>
        );
    }

    private sort = (a: IContainsFileName, b: IContainsFileName) => {
        if (a.fileName < b.fileName) {
            return -1;
        } else if (a.fileName > b.fileName) {
            return 1;
        }
        // a must be equal to b
        return 0;

    }

    private renderSelectedFiles = () => {
        if (this.state.selectedFiles.length > 0) {
            const selectedFiles = JSON.parse(JSON.stringify(this.state.selectedFiles)).sort(this.sort);
            return (
                <div>
                    <label className="file-selector__label">{this.props.field.additional.labels.selectedFiles}</label>
                    <div>
                        {
                            selectedFiles.map((file, index) => {
                                return (
                                    <div className='file-selector__selected-file' key={kendo.guid()} ref={(r) => file.labelRef = $(r)}>
                                        <span> {file.fileName}</span>
                                        {
                                            this.props.disabled ?
                                                null :
                                                <span className="file-selector__remove" title="Remove" onClick={() => this.removeFile(index, file)}>{String.fromCharCode(10007)}</span>
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    private renderSelectedDocuments = () => {
        if (this.state.selectedDocuments.length > 0) {
            const selectedDocuments = JSON.parse(JSON.stringify(this.state.selectedDocuments)).sort(this.sort);
            return (
                <div>
                    <label className="file-selector__label">{this.props.field.additional.labels.selectedDocuments}</label>
                    <div>
                        {
                            selectedDocuments.map((doc, index) => {
                                return (
                                    <div className='file-selector__selected-doc' key={kendo.guid()} ref={(r) => doc.labelRef = $(r)}>
                                        <span> {doc.fileName} {doc.id !== null ? "(" + doc.id + ")" : ""} </span>
                                        {
                                            this.props.disabled ?
                                                null :
                                                <span className="file-selector__remove" title="Remove" onClick={() => this.removeDoc(index, doc)}>{String.fromCharCode(10007)}</span>
                                        }
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    private renderSelectedElements = () => {
        return (
            <div>
                {this.renderSelectedFiles()}
                {this.renderSelectedDocuments()}
            </div>
        );
    }

    private getDocumentType = (appContext: string) => {       
        switch (appContext) {
            case "address":
                return DocumentReferenceType.Address;
            case "machine":
                return DocumentReferenceType.Machine;
            case "ticket":
                return DocumentReferenceType.Ticket;
            case "project":
                return DocumentReferenceType.Project;
            case "resourcePlanning":
                return DocumentReferenceType.Delegation;
            case "resource":
                return DocumentReferenceType.Resource;
            case "salesQuotation":
            case "salesOrder":
                return DocumentReferenceType.CommDocument;
            case "serviceReport":
            case "weeklyReport":
                return DocumentReferenceType.Beleg;
            case "Parts":
                return DocumentReferenceType.Article;
            case "editTravelReport":
                return DocumentReferenceType.TravelReport;
            default:
                console.error(`'${appContext}' isn't mapped`);
                return "";
        }
    }

    componentDidMount() {
        this.props.commandManager.registerExecutor("emailAttachment", (command, data: { existingFiles, existingDocuments: DocumentWrapper []}) => {
            if (command === Commands.DYNAMIC) {
                if (Array.isArray(data.existingFiles) || Array.isArray(data.existingDocuments)) {
                    let files: Array<FileWrapper> = [];
                    let documents: Array<DocumentWrapper> = [];

                    if (Array.isArray(data.existingFiles)) {
                        files = data.existingFiles.map((file) => {
                            return {
                                elementRef: null,
                                file: null,
                                fileName: file,
                                labelRef: null,
                                filePath: null
                            };
                        }); 
                    }

                    if (Array.isArray(data.existingDocuments)) {
                        documents = data.existingDocuments;
                    }
                    this.setState({
                        selectedDocuments: documents,
                        selectedFiles: files
                    })
                }
            }
        });
        this.props.commandManager.runCommand("emailAttachmentMounted", Commands.DYNAMIC);
    }

    render() {
        return (
            <div>
                {this.renderSelectors()}
                {this.renderSummary()}
                {this.renderSelectedElements()}
            </div>
        );
    }
}

interface EmailFileSelectorField extends BaseField {
    additional?: {
        labels: {
            local: string;
            document: string;
            noFiles: string;
            existingFiles: string;
            existingDocuments: string;
            selectedFiles: string;
            selectedDocuments: string;
        }
    }
}

interface EmailFileSelectorProps extends BaseComponentProps {
    field: EmailFileSelectorField;
    commandManager: CommandManagerAPI;
    context: EmailPropsContext;
}

interface AttachmentsSelectorState {
    selectedFiles: Array<FileWrapper>;
    selectedDocuments: Array<DocumentWrapper>
}

interface IContainsFileName {
    fileName: string;
}

export interface FileWrapper extends IContainsFileName {
    file: File;
    elementRef: JQuery;
    labelRef: any;
    filePath: string;
}

export interface DocumentWrapper extends IContainsFileName {
    documentName: string;
    id: number;
    docObject: any;
    labelRef: any;
}